module.exports = __webpack_public_path__ + "static/media/Doctor.55b7bdb3.png";